/*
* @Author: babysoft08
* @Date:   2025-09-09 12:56:55
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-09-09 13:41:37
*/
export const multiplierData = [
	{
		"multiplier_code":"G1",
		"multiplier":"Not Set",
		"page" : {
			"1-8" : "GR3/GX3 - Cast Iron - NEMA Premium - Severe Duty",
			"9-14" : "XR3 - Cast Iron - NEMA Premium - Severe Duty",
			"15-17" : "GR3 - ODP - General Purpose",
			"18-19" : "XR3 - ODP - General Purpose"
		}
	},
	{
		"multiplier_code":"AG",
		"multiplier":"Not Set",
		"page" : {
			"19-22" : "GR3 - Aluminum - NEMA Premium"
		}
	},
	{
		"multiplier_code":"SD",
		"multiplier":"Not Set",
		"page" : {
			"22-28" : "IEEE 841 - Severe Duty"
		}
	},
	{
		"multiplier_code":"W1",
		"multiplier":"Not Set",
		"page" : {
			"28-31" : "White Epoxy - Wash-down Duty"
		}
	},
	{
		"multiplier_code":"R1",
		"multiplier":"Not Set",
		"page" : {
			"31-32" : "High Torque - Single Phase - Farm Duty Motors"
		}
	},
	{
		"multiplier_code":"O1",
		"multiplier":"Not Set",
		"page" : {
			"33" : "Crusher Duty Motors"
		}
	},
	{
		"multiplier_code":"B1",
		"multiplier":"Not Set",
		"page" : {
			"34-35" : "Black Line - Ultra High Slip - Oil Well Pumper"
		}
	},
	{
		"multiplier_code":"P1",
		"multiplier":"Not Set",
		"page" : {
			"35-38" : "Close Coupled JM / JP Pump Motors",
			"39-43" : "XR3 - Close Coupled JM / JP Pump Motors"
		}
	},
	{
		"multiplier_code":"IE",
		"multiplier":"Not Set",
		"page" : {
			"44-49" : "IEC Motor Line",
			"50-56" : "XR3 - IEC Motor Line"
		}
	},
	{
		"multiplier_code":"CB",
		"multiplier":"Not Set",
		"page" : {
			"57-58" : "Cobra Motor Line",
			"59-62" : "XR3 - Cobra Motor Line",
			"63-65" : "CB1 - Cobra Single Phase Motor Line"
		}
	},
	{
		"multiplier_code":"CT",
		"multiplier":"Not Set",
		"page" : {
			"66" : "Cooling Tower Line",
			"67-68" : "XR3 - Cooling Tower Line"
		}
	},
	{
		"multiplier_code":"X1",
		"multiplier":"Not Set",
		"page" : {
			"68-72" : "Division 1 - Hazardous Location"
		}
	},
	{
		"multiplier_code":"DC",
		"multiplier":"Not Set",
		"page" : {
			"73-74" : "PMDC Motor Line"
		}
	},
	{
		"multiplier_code":"PC",
		"multiplier":"Not Set",
		"page" : {
			"74-75" : "Rotary Transformers (Phase Converter)"
		}
	},
	{
		"multiplier_code":"BK",
		"multiplier":"Not Set",
		"page" : {
			"76-79" : "Brake Motors (IEC and NEMA)"
		}
	}
	,
	{
		"multiplier_code":"SS",
		"multiplier":"Not Set",
		"page" : {
			"80-82" : "IP69K - Stainless Steel - 56C - Three Phase"
		}
	}
];